import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

const _base = "zxStudentRoll/";

// 学生 - 获取当前学生学籍
export const getMyRoll = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getMyRoll", {
           data: _params,
           method: "GET",
         });
       };
// 学生 - 获取当前学生基本信息
export const getMyStudent = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "getMyStudent", {
           data: _params,
           method: "GET",
         });
       };


// WEBPACK FOOTER //
// ./src/fetch/api/studentRoll.js